<template>
  <ListModule
    @click="click"
    @more="more"
    :index="index"
    :config="config"
    :data="data"
    :isEditMode="isEditMode"
    :hideEditButton="true"
  >
  </ListModule>
</template>

<script>
import ListModule from './ListModule.vue'
export default {
  components: {
    ListModule
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    config: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click () { this.$emit('click') },
    more () { this.$emit('more') }
  }
}
</script>

<style lang="postcss" scoped>
</style>



// WEBPACK FOOTER //
// src/containers/module/TalkModule.vue